@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row items-start w-full">
      @if (field.browserOpts.inLineWithCaption) {
        <mat-label class="mr-2 font-medium">
          {{ field.label | localize }}
        </mat-label>
      }
      <mat-form-field class="w-full">
        @if (!field.browserOpts.inLineWithCaption) {
          <mat-label>{{ field.label | localize }}</mat-label>
        }
        @switch (field.view) {
          @case ('TEXT') {
            <input matInput [type]="field.isPassword && !showPassword ? 'password' : 'text'"
              [formControl]="field.control" [placeholder]="field.placeholder | localize"
                        [readonly]="field.readonly" [required]="field.required" [ngClass]="{
                                'text-left': field.browserOpts.alignment === 'LEFT',
                                'text-center': field.browserOpts.alignment === 'CENTER', 
                                'text-right': field.browserOpts.alignment === 'RIGHT',
                                'uppercase': field.transform === 'UPPERCASE',
                                'lowercase': field.transform === 'LOWERCASE'
                            }" />
              @if (field.isPassword) {
                <button mat-icon-button matSuffix type="button"
                  (click)="showPassword = !showPassword">
                  <mat-icon [svgIcon]="showPassword ? 'heroicons_outline:eye' : 'heroicons_outline:eye-off'">
                  </mat-icon>
                </button>
              }
            }
            @case ('TEXTAREA') {
              <textarea matInput [formControl]="field.control" [placeholder]="field.placeholder | localize"
                        [rows]="field.rows" [cols]="field.cols" [readonly]="field.readonly" [required]="field.required" [ngClass]="{
                                'text-left': field.browserOpts.alignment === 'LEFT',
                                'text-center': field.browserOpts.alignment === 'CENTER',
                                'text-right': field.browserOpts.alignment === 'RIGHT',
                                'uppercase': field.transform === 'UPPERCASE',
                                'lowercase': field.transform === 'LOWERCASE'
                            }"></textarea>
            }
          }
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (field.control.hasError('required') && !field.readonly) {
            <mat-error>
              {{ 'errorRequiredField' | transloco }}
            </mat-error>
          }
          @if (field.control.hasError('minlength') && !field.readonly) {
            <mat-error>
              {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
            </mat-error>
          }
          @if (field.control.hasError('maxlength') && !field.readonly) {
            <mat-error>
              {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
            </mat-error>
          }
          @if (field.control.hasError('pattern') && !field.readonly) {
            <mat-error>
              {{ field.control.errors.pattern.hint ? (field.control.errors.pattern.hint | localize) : ('errorPattern' | transloco) }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  } @else {
    {{ field.control.value }}
  }

